import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.deferredModal.title',
        defaultMessage: 'This application is deferred.'
    }
});
